import { useMutation } from "@tanstack/react-query";
import { createFacility } from "../services/FacilityService";

export function useFacilityCreate() {
    return useMutation({
        mutationFn: createFacility,
    });
}
